module.exports = __webpack_public_path__ + "img/profil_lapper_anne-grete.3b0010c6.png";